import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "text-2xl font-bold mb-4" }
const _hoisted_2 = { class: "space-y-6 text-sm" }
const _hoisted_3 = ["onMouseenter"]
const _hoisted_4 = { class: "relative z-10" }
const _hoisted_5 = { class: "font-bold" }
const _hoisted_6 = { class: "italic" }
const _hoisted_7 = {
  key: 0,
  class: "italic"
}
const _hoisted_8 = {
  key: 1,
  class: "list-disc ml-5 mt-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h2", _hoisted_1, _toDisplayString(_ctx.$t("workExperience")), 1),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.jobs, (job) => {
        return (_openBlock(), _createElementBlock("div", {
          key: job.id,
          class: "p-4 rounded-xl transition-all duration-300 hover:shadow-lg relative group",
          onMouseenter: ($event: any) => (_ctx.emitSkillIds(job.skillIds)),
          onMouseleave: _cache[0] || (_cache[0] = ($event: any) => (_ctx.emitSkillIds([])))
        }, [
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "absolute inset-0 rounded-xl transition-opacity duration-300 opacity-0 group-hover:opacity-100 bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-sm pointer-events-none" }, null, -1)),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.$t(job.title)), 1),
            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t(job.company)), 1),
            (job.period)
              ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.$t(job.period)), 1))
              : _createCommentVNode("", true),
            (job.responsibilities)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_8, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getResponsibilities(job.responsibilities), (resp, idx) => {
                    return (_openBlock(), _createElementBlock("li", { key: idx }, _toDisplayString(resp), 1))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ])
        ], 40, _hoisted_3))
      }), 128))
    ])
  ]))
}